module.exports = __webpack_public_path__ + "static/media/image-card-1.f05c6b92.png";